import {createTheme} from '@mui/material';

const palette = {
  primary: {
    main: '#16A29A',
    light: '#7fcbb4',
  },
  gray: {
    50: '#FAFAFA',
    100: '#f3f4f6',
    200: '#F4F4F4',
    300: '#EAEAEA',
    400: '#D3D3D3',
    500: '#BCBCBC',
    600: '#959595',
    700: '#747474',
    800: '#505050',
    900: '#323232',
    light: '#F5F5F5',
    dark: '#B5BDD3',
  },
};

export const buildrzTheme = createTheme({
  typography: {
    fontFamily: ['noto-sans-display', 'aktiv-grotesk', 'sans-serif'].join(','),
  },
  palette,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '8px 10px',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: palette.primary.light,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            minHeight: '30px',
          },
        },
        content: {
          '&.Mui-expanded': {
            margin: '15px 0 10px',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          paddingTop: '8px',
          paddingBottom: '8px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: 'inherit',
          fontWeight: 400,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          // button is for increase css specificity and override tailwind
          // base styles
          'button&': {
            background: palette.primary.main,
          },
          'button&:hover': {
            background: palette.primary.light,
          },
        },
        outlined: {
          borderColor: palette.gray[400],
          color: palette.gray[800],
          '&:hover': {
            borderColor: palette.gray[500],
            color: palette.gray[900],
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          'button&': {
            backgroundColor: '#ffffff',
            borderRadius: 8,
            border: `solid 1px ${palette.gray[400]}`,
            color: palette.gray[600],
          },
          'button&:hover': {
            backgroundColor: palette.primary.light,
            borderColor: palette.gray[200],
            color: 'white',
          },
          '& .MuiTouchRipple-root .MuiTouchRipple-child': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          'button&:hover': {
            backgroundColor: palette.primary.light,
            borderColor: palette.gray[200],
            color: 'white',
          },
          '&.Mui-selected': {
            backgroundColor: palette.primary.main,
            borderColor: palette.gray[200],
            color: 'white',
          },
          '&.Mui-selected:hover': {
            backgroundColor: palette.primary.light,
            borderColor: palette.gray[200],
            color: 'white',
          },
        },
      },
    },
  },
});
